import lozad from 'lozad';

class LazyLoadModule {
    constructor() {
        this.observer = null;

        this.initialize();
    }

    initialize() {
        this.observer = lozad('.js-lzld', {
            rootMargin: `0px 0px`,
            threshold: 0.1,

            load: (el) => {
                const event = new CustomEvent("lazy:done");

                el.src = el.getAttribute('data-src');

                if (el.getAttribute('data-srcset')) {
                    el.setAttribute('srcset', el.getAttribute('data-srcset'));
                }

                setTimeout(() => {
                    document.body.dispatchEvent(event);
                }, 100);
            }
        });

        this.observer.observe();
    }
}

export default LazyLoadModule;
